<template>
  <network-case-library v-if="isBuiltInLibrary" />
  <policy-case-library v-else-if="isPolicyLibrary" />
  <policy-training-home v-else-if="isPolicyTraining" />
  <policy-custom-cases v-else-if="isPolicyCustom" ref="policy" />
  <case-management v-else :key="managementKey" />
</template>

<script>
import NetworkCaseLibrary from './NetworkCaseLibrary.vue'
import CaseManagement from './CaseManagement.vue'
import PolicyCustomCases from './PolicyCustomCases.vue'
import PolicyTrainingHome from './PolicyTrainingHome.vue'
import PolicyCaseLibrary from './PolicyCaseLibrary.vue'

export default {
  name: 'Cases',
  components: { NetworkCaseLibrary, CaseManagement, PolicyCustomCases, PolicyTrainingHome, PolicyCaseLibrary },
  async beforeRouteLeave (to, from, next) { next(!this.$refs.policy || !this.$refs.policy.dirty || await this.$messageBox.confirm('政策案例尚有未保存修改，确认离开？')) },
  computed: {
    isPolicyTraining () { return this.$route.query.module === 'policy' && this.$route.query.view === 'experience' },
    isPolicyLibrary () { return this.$route.query.module === 'policy' && !this.$route.query.view },
    isPolicyCustom () { return this.$route.query.module === 'policy' && this.$route.query.view === 'custom' },
    isBuiltInLibrary () {
      return this.$route.query.module !== 'policy' && !this.$route.query.view
    },
    managementKey () {
      return `${this.$route.query.module || 'network'}:${this.$route.query.view || 'management'}`
    }
  }
}
</script>
